import { Badge, Col, Row } from 'antd';
import get from 'lodash/get';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ReactComponent as BlueCloud } from '../../../images/cloud_message.svg';
import { ReactComponent as WhiteCloud } from '../../../images/white_cloud.svg';
const Wrapper = styled.div`
  &&& {
    &:nth-child(1) {
      border-top: 1px solid #e0e0e0;
    }
    background: white;
    border-bottom: 1px solid #e0e0e0;
  }
`;

const BadgeStyle = styled(Badge)`
  &&& {
    sup.ant-scroll-number.ant-badge-count {
      width: 20px;
      height: 20px;
      min-width: 0;
      align-items: center;
      display: flex;
      justify-content: center;
      font-size: 11px;
      border: 2px solid #f4f5f6;
    }
  }
`;

function ItemTicket({
  count,
  name,
  theme,
  id,
  openDialog,
  currentTiket,
  last,
}) {
  // const idTiket = useSelector((state) => get(state, `chat.idTiket`, null));
  return (
    <Wrapper>
      <div
        onClick={() => {
          openDialog(id);
        }}
        className={
          currentTiket === id
            ? 'item cursor-pointer pr-30 pl-60 pb-20 pt-20 bg-primary text-white'
            : 'item cursor-pointer pr-30 pl-60 pb-20 pt-20 bg-white'
        }
      >
        <Row justify="space-between" align="middle">
          <Col span={20}>
            <div className="flex justify-between mb-12">
              <div
                className={
                  currentTiket === id
                    ? 'text-white border-b-1 border-dotted'
                    : 'text-black border-b-1 border-dotted'
                }
              >
                {last.manager
                  ? `${last.manager.first_name} ${last.manager.last_name}`
                  : name}
              </div>
              <div className="text-12">{id}</div>
            </div>
            <div className="font-bold truncate">{theme}</div>
          </Col>
          <Col className="relative" span={4}>
            <BadgeStyle
              style={
                currentTiket === id
                  ? { borderColor: '#4B97E9' }
                  : { borderColor: 'white' }
              }
              className="absolute right-0 -top-10"
              count={count}
            >
              {currentTiket === id ? <WhiteCloud /> : <BlueCloud />}
            </BadgeStyle>
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
}

ItemTicket.propTypes = {};

export default ItemTicket;
